// extracted by mini-css-extract-plugin
export var container = "Service-module--container--1xdjb";
export var serviceIntro = "Service-module--serviceIntro--DXJ+T";
export var bgServiceTitleFdm = "Service-module--bgServiceTitleFdm--SuSsv";
export var bgServiceTitleHuriuri = "Service-module--bgServiceTitleHuriuri--RFkfu";
export var companyLink = "Service-module--companyLink--ejfMh";
export var bgService = "Service-module--bgService--syroU";
export var bgServiceHuriuri = "Service-module--bgServiceHuriuri--iqTMY";
export var bgServiceFdm = "Service-module--bgServiceFdm--Gfhzr";